import React from 'react'
import '../style/Footer.css';
import { Link } from 'react-router-dom';
import { HashLink as Link2 } from 'react-router-hash-link';

import Logo from '../img/logo_r3act.png';

export default function Footer() {
  return (
    <footer className='d-flex bg-dark mt-auto mb-2 pt-3'>
      <a href="/#Home">
        <img src={Logo} alt="Logo R3ACT Bar" width="70" className="footer-logo m-5 my-3" />
      </a>      
      <section className="d-flex justify-content-evenly w-100 my-auto mb-2">
        <div className="footer-section">
          <h2 className="footer-list-title">MENÚ</h2>
          <ul className="footer-list">
						<li><Link to="/">Home</Link></li>
						<li><Link to="/productos">Productos</Link></li>
						<li><Link2 to="/#contacto">Contacto</Link2></li>
          </ul>
        </div>

        <div className="footer-section redes">
          <h2 className="footer-list-title">REDES</h2>
          <ul className="footer-list">
            <li><a href="https://facebook.com/"><i className="bi bi-facebook"></i> Facebook</a></li>
            <li><a href="https://instagram.com/"><i className="bi bi-instagram"></i> Instagram</a></li>
            <li><a href="https://tiktok.com/"><i className="bi bi-tiktok"></i>TikTok</a></li>
          </ul>
        </div>

        <div className="footer-section ubicacion">
          <h2 className="footer-list-title">UBICACIÓN</h2>
          <p className='m-0'>Monte de Oca 2356, CABA</p>
          <iframe 
						style={{ filter: "invert(90%) hue-rotate(180deg)" }} 
            title='map'
            className="footer-iframe"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.0392303583562!2d-58.37309602336411!3d-34.65371217293643!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a334aab78be889%3A0xe808082ff7311cac!2sAv.%20Montes%20de%20Oca%202356%2C%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1693074691566!5m2!1sen!2sar"
            allowfullscreen="" loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </section>
    </footer>
  )

}

